/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of privcats (patients) to display or load privcats */


(function () {
  'use strict';
  angular.module('vcfinance.privcat')
    .component('privcatgroupchooser', {
      restrict: 'E',
      bindings: {
        privcatgroups: '<?',
        onselectcb: '&'
      },
      template: `
          <div class="row">
              <div class="col-xs-12 col-md-4" ng-repeat="group in vm.privcatgroups">
                  <span class="btn btn-success btn-xs" 
                     uib-tooltip="Leistungen der Gruppe hinzufügen"
                     ng-click="vm.addServiceOrGroup(group)"><i class="fa fa-cart-plus"></i>&nbsp;{{group.name}}</span>
              </div>
              <div class="col-xs-12" ng-show="vm.privcatgroups.length === 0" class="alert alert-info">Sie haben noch keine Leistungsgruppen angelegt. <a ui-sref="settings.services" class="btn btn-primary" target="_blank">Leistungsgruppe anlegen</a></div>
          </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Rlog', 'Privcat', 'vertxEventBusService',
        function ($log, Rlog, Privcat, vertxEventBusService) {
          let vm = this;

          vm.addServiceOrGroup = addServiceOrGroup;

          vm.$onInit = function () {
            // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
            if (angular.isUndefined(vm.privcatgroups)) {
              vm.privcatgroups = Privcat.$search({type: 'group', active: true});
            }
          }; // $onInit()
          
          
          function addServiceOrGroup(group) {
             if (angular.isDefined(vm.onselectcb) && angular.isFunction(vm.onselectcb)) {
               let cleangroup = {};
               cleangroup._id = group._id;
               cleangroup.name = group.name;
               cleangroup.shortcut = group.shortcut;
               cleangroup.details = group.details;
               cleangroup.type = group.type;
               cleangroup.active = group.active;
               cleangroup.items = angular.copy(group.items);

               vm.onselectcb({privcat: cleangroup, privcatref: cleangroup._id});
             }
          }
          
          vertxEventBusService.on('privcat.update', function (message) {
            $log.debug('debug: privcat update received: ', message);
            let messages = message.split(':');
            vm.privcatgroups.$refresh().$then(function () {
              $log.debug('debug: privcatgrouplist refreshed privcat');
            }, function (error) {
              $log.debug('debug: privcatgrouplist refresh failed: ', error);
            });
          });
          
          
          
          
        }] // controller
    }); // component
  
  // klammerfriedhof
}());